import { Language } from "api/type";
import { LanguageContext } from "contexts";
import React from "react";
import { getTranslation } from "utils/translate";
import NormalText from "../NormalText";

type SoundOnProps = {};

const SoundOn: React.FC<SoundOnProps> = () => {
  const language = React.useContext<Language>(LanguageContext)[0];

  return (
    <div
      style={{
        display: "flex",
        position: "relative",
        flexDirection: "column",
        padding: "3px",
        borderRadius: "5px",
        backgroundColor: "#DEDEDE32",
        // width: "70px",
        gap: "3px",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "3px",
          margin: "0 auto",
        }}
      >
        <svg
          width="28"
          height="20"
          viewBox="0 0 28 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.26583 13.2335C8.79741 12.7645 8.16192 12.5007 7.49906 12.5001H4.16555C3.94452 12.5001 3.73255 12.4123 3.57626 12.256C3.41997 12.0998 3.33217 11.8878 3.33217 11.6668V8.33324C3.33217 8.11222 3.41997 7.90024 3.57626 7.74395C3.73255 7.58767 3.94452 7.49986 4.16555 7.49986H7.49906C8.16192 7.49928 8.79741 7.23549 9.26583 6.76649L13.4044 2.6296C13.467 2.56736 13.5465 2.52506 13.6331 2.50801C13.7197 2.49097 13.8094 2.49995 13.8909 2.53383C13.9724 2.56771 14.042 2.62496 14.091 2.69836C14.14 2.77177 14.1661 2.85804 14.1661 2.94628V17.0537C14.1661 17.142 14.14 17.2282 14.091 17.3016C14.042 17.375 13.9724 17.4323 13.8909 17.4662C13.8094 17.5 13.7197 17.509 13.6331 17.492C13.5465 17.4749 13.467 17.4326 13.4044 17.3704L9.26583 13.2335ZM4.16555 4.99973H7.49906L11.636 0.862833C12.0481 0.450822 12.5731 0.170252 13.1447 0.0565938C13.7162 -0.0570648 14.3086 0.00129118 14.847 0.224284C15.3854 0.447278 15.8456 0.824895 16.1694 1.3094C16.4932 1.7939 16.6661 2.36353 16.6662 2.94628V17.0537C16.6661 17.6365 16.4932 18.2061 16.1694 18.6906C15.8456 19.1751 15.3854 19.5527 14.847 19.7757C14.3086 19.9987 13.7162 20.0571 13.1447 19.9434C12.5731 19.8297 12.0481 19.5492 11.636 19.1372L7.49906 15.0003H4.16555C3.28144 15.0003 2.43355 14.6491 1.8084 14.0239C1.18324 13.3988 0.832031 12.5509 0.832031 11.6668V8.33324C0.832031 7.44914 1.18324 6.60125 1.8084 5.97609C2.43355 5.35093 3.28144 4.99973 4.16555 4.99973ZM24.4367 18.5055C23.995 19.0372 23.1983 19.0322 22.7099 18.5455C22.2232 18.0571 22.2299 17.2687 22.6582 16.7287C24.1782 14.8157 25.0039 12.4434 25 10C25.0039 7.55663 24.1782 5.18432 22.6582 3.2713C22.2299 2.73127 22.2232 1.94289 22.7099 1.45453C23.1983 0.967838 23.995 0.964505 24.4367 1.49453C26.4212 3.88412 27.5052 6.8938 27.5002 10C27.5002 13.2335 26.3501 16.197 24.4367 18.5055ZM20.8731 14.9469C20.4631 15.502 19.6631 15.497 19.1747 15.0086C18.6863 14.5202 18.7013 13.7352 19.0747 13.1535C19.6803 12.2133 20.0015 11.1183 19.9997 10C19.9997 8.83827 19.6597 7.75488 19.0747 6.84649C18.7013 6.26646 18.6863 5.47975 19.1747 4.99139C19.6631 4.50303 20.4631 4.49803 20.8748 5.05306C21.8949 6.43647 22.4999 8.1499 22.4999 10C22.5027 11.7808 21.9323 13.5153 20.8731 14.9469Z"
            fill="black"
          />
        </svg>
        <svg
          width="26"
          height="20"
          viewBox="0 0 26 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.55469 4.99935L12.832 1.66602M12.832 1.66602L17.1093 4.99935M12.832 1.66602V18.3327"
            stroke="black"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <NormalText
        textContent={getTranslation("soundOn", language)}
        style={{ fontWeight: 700 }}
      />
    </div>
  );
};

export default SoundOn;
